import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting/sundry-costs";

export default {
  getSundryCost(id) {
    return Repository.get(`${resource}/${id}`)
  },
  getSundryCostList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSundryCost(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteSundryCost(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateSundryCost(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
